import { type RefObject, useLayoutEffect } from "react";

/**
 * Grows a textarea to fit its content up to `maxHeight`, then scrolls. Re-runs
 * whenever `value` changes so the composer pill expands as you type and snaps
 * back after sending. Pure side-effect on the referenced node.
 */
export function useAutosizeTextarea(
  ref: RefObject<HTMLTextAreaElement | null>,
  value: string,
  maxHeight = 200,
): void {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  }, [ref, value, maxHeight]);
}
